module.exports = __webpack_public_path__ + "img/ES.453c6cb1.png";